import { useLanguage } from './language-context';
import { NavIcon } from './nav-icon';

// The coming-later state for a nav entry whose content is deferred (PRD v2.5
// §7.3.3 row 6: /promote is a nav entry only — self-serve Promote is out of launch
// scope, DR-32, §14.1). No campaign builder, no SMS wallet, no push slots: just an
// honest "coming later" page. Lives in shell/ because CB-18 forbids a promote/ screen
// folder until the feature is un-deferred.
export function DeferredPage() {
  const { t } = useLanguage();
  return (
    <section className="shell-state" aria-labelledby="deferred-title" data-deferred="promote">
      <span className="shell-state__tile">
        <NavIcon name="megaphone" size={24} />
      </span>
      <span className="shell-state__chip">{t('dc70.nav.soon')}</span>
      <h1 id="deferred-title" className="shell-state__title">
        {t('dc70.soon.title')}
      </h1>
      <p className="shell-state__body">{t('dc70.soon.body')}</p>
    </section>
  );
}
